import React, {useEffect, useState} from 'react';
import {FiCalendar, FiChevronLeft, FiChevronRight, FiEye, FiHome} from "react-icons/fi";
import {useTranslation} from "react-i18next";
import Modal from "./Modal";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {
  getFinancialReports,
  getFinancialStatistics,
  getFinancialStatisticsOperators,
  getOmanCampaignStatistics
} from "../services/customSdpApiService";
import DatePicker from "react-datepicker";
import {Line} from "react-chartjs-2";
import {monthNames} from "../ressources/static";
import {getCampaignStatistics, getCampaignStatisticsDetails} from "../services/campaignStatisticsService";


const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

function OmanTelRevenueModal(){
  const navigate = useNavigate();

  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get('/data.json')
      .then((response) => {
        setData(response.data.OMANTELRevenue);
      })
      .catch((error) => {
        console.error('Error fetching the JSON file:', error);
      });
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  const totalRevenue = data.reduce((acc, row) => acc + parseFloat(row.revenue.replace(/,/g, '')), 0);
  const totalShare = data.reduce((acc, row) => acc + parseFloat(row.share.replace(/,/g, '')), 0);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
        <tr>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Month</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Total Revenue SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Taqniyat Share</th>
        </tr>
        </thead>
        <tbody>
        {data.map((row, index) => (
          <tr key={index} className="hover:bg-gray-100">
            <td onClick={()=> navigate('/revenue-analysis') } className="cursor-pointer border border-gray-300 px-4 py-2">{row.date}</td>
            <td className="border border-gray-300 px-4 py-2">{row.revenue}</td>
            <td className="border border-gray-300 px-4 py-2">{row.share}</td>
          </tr>
        ))}
        <tr className="font-bold bg-gray-200">
          <td className="py-2 px-4 border-t border-gray-300">Total</td>
          <td className="py-2 px-4 border-t border-gray-300">
            {totalRevenue.toLocaleString()}
          </td>
          <td className="py-2 px-4 border-t border-gray-300">
            {totalShare.toLocaleString()}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
}

function RevenueModal({opId, dataYear}){

  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalShare, setTotalShare] = useState(0);

  const fetchRevenue = async ()=>{
    const submitData = {
      opId: opId,
      year: dataYear
    }
    await getFinancialStatistics(submitData)
      .then((res)=>{
        console.log(res);
        setData(res.revenueByMonth?.sort((a,b)=> a.month - b.month ))
        setTotalRevenue(res.totalRevenue)
        setTotalShare(res.totalSPShare)
      })
      .catch((err)=>console.log(err));
  }

  useEffect(() => {
    fetchRevenue();
  }, [dataYear]);

  if (!data) {
    return <div>Loading...</div>;
  }


  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
        <tr>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Month</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Total Revenue SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Taqniyat Share</th>
        </tr>
        </thead>
        <tbody>
        {data.map((row, index) => (
          <tr key={index} className="hover:bg-gray-100">
            <td onClick={()=> navigate('/revenue-analysis') } className="cursor-pointer border border-gray-300 px-4 py-2">
              {months[parseInt(row.month) - 1] || ""}
            </td>
            <td className="border border-gray-300 px-4 py-2">
              {row.revenue?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </td>
            <td className="border border-gray-300 px-4 py-2">
              {row.spShare?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </td>
          </tr>
        ))}
        <tr className="font-bold bg-gray-200">
          <td className="py-2 px-4 border-t border-gray-300">Total</td>
          <td className="py-2 px-4 border-t border-gray-300">
            {totalRevenue?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
          <td className="py-2 px-4 border-t border-gray-300">
            {totalShare?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
}

function CampaignStatisticsModal({opId, dataYear}){

  const navigate = useNavigate();

  const [data, setData] = useState(null);

  const [totalSpent, setTotalSpent] = useState(0);
  const [totalRevenueEstimated, setTotalRevenueEstimated] = useState(0);
  const [totalRevenueEarned, setTotalRevenueEarned] = useState(0);

  const fetchRevenue = async ()=>{
    const submitData = {
      opId: opId,
      year: dataYear
    }

    // await getCampaignStatistics(submitData)
    //   .then(res=>{
    //     console.log(res);
    //   })

    await getCampaignStatisticsDetails(submitData)
      .then((res)=>{
        console.log(res);
        setData(res);

        let totalSpent = 0;
        let totalRevenueEstimated = 0;
        let totalRevenueEarned = 0;

        res.forEach(item => {
          totalSpent += item.TotalCostSAR_Year;
          totalRevenueEstimated += item.RevenueEstimateSAR;
          totalRevenueEarned += item.RevenueEarnedSAR;
        });

        setTotalSpent(totalSpent);
        setTotalRevenueEstimated(totalRevenueEstimated);
        setTotalRevenueEarned(totalRevenueEarned);

      })
      .catch((err)=>console.log(err));
  }

  useEffect(() => {
    fetchRevenue();
  }, [dataYear]);

  if (!data) {
    return <div>Loading...</div>;
  }


  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
        <tr>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Service</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Spent SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Revenue estimated SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Revenue earned SAR</th>
        </tr>
        </thead>
        <tbody>
        {data.map((row, index) => (
          <tr key={index} className="hover:bg-gray-100">
            <td className="cursor-pointer border border-gray-300 px-4 py-2">
              {row?.ServiceName}
            </td>
            <td className="border border-gray-300 px-4 py-2">
              {row.TotalCostSAR_Year?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </td>
            <td className="border border-gray-300 px-4 py-2">
              {row.RevenueEstimateSAR?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </td>
            <td className="border border-gray-300 px-4 py-2">
              {row.RevenueEarnedSAR?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </td>
          </tr>
        ))}
        <tr className="font-bold bg-gray-200">
          <td className="py-2 px-4 border-t border-gray-300">Total</td>
          <td className="py-2 px-4 border-t border-gray-300">
            {totalSpent?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
          <td className="py-2 px-4 border-t border-gray-300">
            {totalRevenueEstimated?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
          <td className="py-2 px-4 border-t border-gray-300">
            {totalRevenueEarned?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
}

function TotalMarketRevenueTable({dataYear, ksaTotal, omanTotal}) {
  return (
    <div className='bg-white p-0 rounded-lg mt-4 shadow overflow-y-auto flex-nowrap text-sm'>
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
        <tr>
          <th colSpan="4"
              className="border border-gray-300 px-4 py-2 bg-azure text-white text-center text-lg font-semibold">
            Total Market revenue {dataYear}
          </th>
        </tr>
        <tr>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Country</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Total Revenue SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Taqniyat Share</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Last update</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td className="border border-gray-300 px-4 py-2">KSA</td>
          <td className="border border-gray-300 px-4 py-2">
            {ksaTotal?.TotalRevenue?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
          <td className="border border-gray-300 px-4 py-2">
            {ksaTotal?.TotalSPShare?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
          <td className="border border-gray-300 px-4 py-2">
            {months[parseInt(ksaTotal?.lastMonth) - 1] || ""}
          </td>
        </tr>
        <tr>
          <td className="border border-gray-300 px-4 py-2">OMAN</td>
          <td className="border border-gray-300 px-4 py-2">
            {omanTotal?.TotalRevenue?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
          <td className="border border-gray-300 px-4 py-2">
            {omanTotal?.TotalSPShare?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
          <td className="border border-gray-300 px-4 py-2">
            {months[parseInt(omanTotal?.lastMonth) - 1] || ""}</td>
        </tr>
        </tbody>
      </table>
    </div>
  )
}

function TotalMarketRevenueV2({dataYear, ksaTotal, omanTotal}){
  return(
    <div className="flex flex-col gap-10">
      <div>
        <div className="flex items-center gap-2 font-semibold mb-2">
          <p>KSA</p>
          <p className="text-gray-500 text-sm"> - Total Market revenue {dataYear}</p>
        </div>
        <div className="grid gap-4 grid-cols-2">
          <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
            <p className="text-gray-500 mb-2 text-sm">Total Revenue SAR</p>
            <p className="text-azure font-bold text-2xl mb-3">
              {ksaTotal?.TotalRevenue?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </p>
            <p className="text-xs font-semibold text-gray-500">
              Last update: {months[parseInt(ksaTotal?.lastMonth) - 1] || ""}
            </p>
          </div>
          <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
            <p className="text-gray-500 mb-2 text-sm">Taqniyat Share SAR</p>
            <p className="text-azure font-bold text-2xl mb-3">
              {ksaTotal?.TotalSPShare?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </p>
            <p className="text-xs font-semibold text-gray-500">
              Last update: {months[parseInt(ksaTotal?.lastMonth) - 1] || ""}
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="flex items-center gap-2 font-semibold mb-2">
          <p>OMAN</p>
          <p className="text-gray-500 text-sm"> - Total Market revenue {dataYear}</p>
        </div>
        <div className="grid gap-4 grid-cols-2">
          <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
            <p className="text-gray-500 mb-2 text-sm">Total Revenue SAR</p>
            <p className="text-azure font-bold text-2xl mb-3">
              {omanTotal?.TotalRevenue?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}            </p>
            <p className="text-xs font-semibold text-gray-500">
              Last update: {months[parseInt(ksaTotal?.lastMonth) - 1] || ""}
            </p>
          </div>
          <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
            <p className="text-gray-500 mb-2 text-sm">Taqniyat Share SAR</p>
            <p className="text-azure font-bold text-2xl mb-3">
              {omanTotal?.TotalSPShare?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </p>
            <p className="text-xs font-semibold text-gray-500">
              Last update: {months[parseInt(ksaTotal?.lastMonth) - 1] || ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

function KsaTotalMarketRevenue({dataYear, ksaTotal}){
  return (
    <div>
      <div className="flex items-center gap-2 font-semibold mb-2">
        <p>KSA</p>
        <p className="text-gray-500 text-sm"> - Total Market revenue {dataYear}</p>
      </div>
      <div className="grid gap-4 grid-cols-2">
        <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
          <p className="text-gray-500 mb-2 text-sm">Total Revenue SAR</p>
          <p className="text-azure font-bold text-2xl mb-3">
            {ksaTotal?.TotalRevenue?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </p>
          <p className="text-xs font-semibold text-gray-500">
            Last update: {months[parseInt(ksaTotal?.lastMonth) - 1] || ""}
          </p>
        </div>
        <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
          <p className="text-gray-500 mb-2 text-sm">Taqniyat Share SAR</p>
          <p className="text-azure font-bold text-2xl mb-3">
            {ksaTotal?.TotalSPShare?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </p>
          <p className="text-xs font-semibold text-gray-500">
            Last update: {months[parseInt(ksaTotal?.lastMonth) - 1] || ""}
          </p>
        </div>
      </div>
    </div>
  )
}

function OmanTotalMarketRevenue({dataYear, omanTotal}){
  return (
    <div>
      <div className="flex items-center gap-2 font-semibold mb-2">
        <p>OMAN</p>
        <p className="text-gray-500 text-sm"> - Total Market revenue {dataYear}</p>
      </div>
      <div className="grid gap-4 grid-cols-2">
        <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
          <p className="text-gray-500 mb-2 text-sm">Total Revenue SAR</p>
          <p className="text-azure font-bold text-2xl mb-3">
            {omanTotal?.TotalRevenue?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </p>
          <p className="text-xs font-semibold text-gray-500">
            Last update: {months[parseInt(omanTotal?.lastMonth) - 1] || ""}
          </p>
        </div>
        <div className="bg-white shadow-customShadow p-3 rounded-lg text-left">
          <p className="text-gray-500 mb-2 text-sm">Taqniyat Share SAR</p>
          <p className="text-azure font-bold text-2xl mb-3">
            {omanTotal?.TotalSPShare?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </p>
          <p className="text-xs font-semibold text-gray-500">
            Last update: {months[parseInt(omanTotal?.lastMonth) - 1] || ""}
          </p>
        </div>
      </div>
    </div>
  )
}

function OperatorsRevenueChartByCountry({dataYear, defaultPage}) {

  const [chartData, setChartData] = useState(null);
  const [page, setPage] = useState(defaultPage || 1);

  useEffect(() => {
    const fetchData = async () => {
      try {

        const ksaOpIds = [3, 4, 2, 9, 7];
        const omanOpIds = [5, 8];

        const operatorsData = await getFinancialStatisticsOperators({
          opIds: page === 1 ? ksaOpIds : omanOpIds,
          year: dataYear,
        });

        const allMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        const colorPalette = [
          'rgba(255, 99, 132, 1)',  // Pink-ish
          'rgba(54, 162, 235, 1)',  // Blue
          'rgba(255, 206, 86, 1)',  // Yellow
          'rgba(75, 192, 192, 1)',  // Teal
          'rgba(153, 102, 255, 1)', // Purple
          'rgba(255, 159, 64, 1)',  // Orange
        ];

        const datasets = operatorsData.map((op, index) => {
          const monthlyRevenues = allMonths.map(m => {
            const found = op.revenueByMonth.find(r => r.month === m);
            return found ? found.revenue : 0;
          });
          const color = colorPalette[index % colorPalette.length];

          return {
            label: `${op.operator}`,
            data: monthlyRevenues,
            // Lines
            borderColor: color,
            borderWidth: 2,
            // Optional fill
            backgroundColor: color.replace(', 1)', ', 0.2)'),
            fill: true,
            pointRadius: 3,
            pointHoverRadius: 5,
          };
        });

        const dataForChart = {
          labels: allMonths.map(m => monthNames[m]),
          datasets,
        };

        setChartData(dataForChart);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dataYear, page]);

  return(
    <div className="relative" >
      <div className="flex items-center justify-between gap-2 mb-2">
        {
          page === 1
            ? <p className="text-gray-500 font-semibold">Ksa total Market revenue by operator {dataYear}</p>
            : <p className="text-gray-500 font-semibold">Oman total Market revenue by operator {dataYear}</p>
        }
        {/*<button*/}
        {/*  onClick={() => setPage(page === 1 ? 2 : 1)}*/}
        {/*  className="bg-white p-2 rounded-full shadow-customShadow"*/}
        {/*>*/}
        {/*  {page === 1 ? <FiChevronRight/> : <FiChevronLeft/>}*/}
        {/*</button>*/}
      </div>
      <div className="h-96" >
        {chartData && (
          <Line
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
            }}
          />
        )}
      </div>
    </div>
  )
}

function TotalMarketRevenueKSATable(props) {

  const {dataYear, openRevenueModal, stcFinancial, mobilyFinancial, zainFinancial, zainFgcFinancial, RBMFinancial} = props;

  const data = [
    {id: 4, title: 'STC', data: stcFinancial},
    {id: 2, title: 'MOBILY', data: mobilyFinancial},
    {id: 3, title: 'ZAIN', data: zainFinancial},
    {id: 9, title: 'ZAIN-FGC', data: zainFgcFinancial},
    {id: 7, title: 'RedBull Mobile', data: RBMFinancial}
  ]

  return (
    <div className='bg-white p-0 rounded-lg mt-4 shadow overflow-y-auto flex-nowrap text-sm'>
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
        <tr>
          <th colSpan="5"
              className="border border-gray-300 px-4 py-2 bg-azure text-white text-center text-lg font-semibold">
            Market revenue KSA {dataYear}
          </th>
        </tr>
        <tr>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Operator</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Total Revenue SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Taqniyat Share</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Last update</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Action</th>
        </tr>
        </thead>
        <tbody>
        {
          data.map((row, index) => (
            <tr key={row.id} >
              <td
                onClick={() => openRevenueModal(row.id)}
                className="border cursor-pointer hover:bg-gray-100 border-gray-300 px-4 py-2">
                {row.title}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                {row.data?.TotalRevenue?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                {row.data?.TotalSPShare?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
              <td className="border border-gray-300 px-4 py-2">{months[parseInt(row.data?.MaxMonth) - 1] || ""}</td>
              <td className="border border-gray-300 px-4 py-2">
                <button>
                  <FiEye size={18} className="hover:text-azure" onClick={() => openRevenueModal(row.id)}/>
                </button>
              </td>
            </tr>
          ))
        }
        </tbody>
      </table>
    </div>
  )
}

function TotalMarketRevenueOmanTable({dataYear, openRevenueModal, omanTelFinancial, oreddoFinancial}){
  const data = [
    {id: 5, title: 'OmanTel', data: omanTelFinancial},
    {id: 8, title: 'Ooredoo', data: oreddoFinancial},
  ]

  return (
    <div className='bg-white p-0 rounded-lg mt-4 shadow overflow-y-auto flex-nowrap text-sm'>
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
        <tr>
          <th colSpan="5"
              className="border border-gray-300 px-4 py-2 bg-azure text-white text-center text-lg font-semibold">
            Market revenue OMAN {dataYear}
          </th>
        </tr>
        <tr>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Operator</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Total Revenue SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Taqniyat Share</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Last update</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Action</th>
        </tr>
        </thead>
        <tbody>
        {
          data.map((row, index) => (
            <tr key={row.id} >
              <td
                onClick={() => openRevenueModal(row.id)}
                className="border cursor-pointer hover:bg-gray-100 border-gray-300 px-4 py-2">
                {row.title}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                {row.data?.TotalRevenue?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                {row.data?.TotalSPShare?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
              <td className="border border-gray-300 px-4 py-2">{months[parseInt(row.data?.MaxMonth) - 1] || ""}</td>
              <td className="border border-gray-300 px-4 py-2">
                <button>
                  <FiEye size={18} className="hover:text-azure" onClick={() => openRevenueModal(row.id)}/>
                </button>
              </td>
            </tr>
          ))
        }
        </tbody>
      </table>
    </div>
  )
}

function CampainStatisticsTable({title, data, openStatisticsModal}) {
  return (
    <div className='bg-white p-0 rounded-lg mt-4 shadow overflow-y-auto flex-nowrap text-sm'>
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
        <tr>
          <th colSpan="4" className="border border-gray-300 px-4 py-2 bg-azure text-white text-center text-lg font-semibold">
            {title}
          </th>
        </tr>
        <tr>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Operator</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Spent SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Revenue estimated SAR</th>
          <th className="border border-gray-300 px-4 py-2 bg-gray-200">Revenue earned SAR</th>
        </tr>
        </thead>
        <tbody>
          {
            data.map((row) => (
              <tr key={row.id} >
                <td
                  onClick={()=> openStatisticsModal(row.opId) }
                  className="border border-gray-300 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  {row.title}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {row.data?.Spent?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) || 0}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {row.data?.RevenueEstimated?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) || 0}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {row.data?.ROI?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) || 0}
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  )
}

function Dashboard() {

  const {t, i18n} = useTranslation();

  const [dataYear, setDataYear] = useState(2025);

  const [zainFinancial, setZainFinancial] = useState({});
  const [stcFinancial, setStcFinancial] = useState({});
  const [mobilyFinancial, setMobilyFinancial] = useState({});
  const [zainFgcFinancial, setZainFgcFinancial] = useState({});
  const [RBMFinancial, setRBMFinancial] = useState({});
  const [omanTelFinancial, setOmanTelFinancial] = useState({});
  const [oreddoFinancial, setOreddoFinancial] = useState({});
  const [ksaTotal, setKsaTotal] = useState({TotalRevenue: 0, TotalSPShare: 0, lastMonth: 1});
  const [omanTotal, setOmanTotal] = useState({TotalRevenue: 0, TotalSPShare: 0, lastMonth: 1});

  const [isRevenueModalOpen, setIsRevenueModalOpen] = useState(false);
  const [isCampaignStatisticsModal, setIsCampaignStatisticsModal] = useState(false);
  const [revenueModalData, setRevenueModalData] = useState(null);

  const [campaignStatisticsStc, setCampaignStatisticsStc] = useState({});
  const [campaignStatisticsMobily, setCampaignStatisticsMobily] = useState({});
  const [campaignStatisticsZain, setCampaignStatisticsZain] = useState({});
  const [campaignStatisticsRbm, setCampaignStatisticsRbm] = useState({});

  const [campaignStatisticsOmanTel, setCampaignStatisticsOmanTel] = useState({});
  const [campaignStatisticsOreddo, setCampaignStatisticsOreddo] = useState({});

  const KsaCampaignStatistics = [
    {id: 1, opId: 4, title: 'STC', data: campaignStatisticsStc},
    {id: 2, opId: 2, title: 'Mobily', data: campaignStatisticsMobily},
    {id: 3, opId: 3, title: 'Zain', data: campaignStatisticsZain},
    {id: 4, opId: 7, title: 'RBM', data: campaignStatisticsRbm},
  ];

  const OmanCampaignStatistics = [
    {id: 1, opId: 5, title: 'OmanTel', data: campaignStatisticsOmanTel},
    {id: 2, opId: 8, title: 'Ooredoo', data: campaignStatisticsOreddo},
  ];

  const openRevenueModal = (opId) => {
    setIsRevenueModalOpen(true);
    setRevenueModalData(opId);
  }

  const closeRevenueModal = () => {
    setRevenueModalData(null);
    setIsRevenueModalOpen(false);
  }

  const openCampaignStatisticsModal = (opId) => {
    setIsCampaignStatisticsModal(true);
    setRevenueModalData(opId);
  }

  const closeCampaignStatisticsModal = () => {
    setRevenueModalData(null);
    setIsCampaignStatisticsModal(false);
  }

  const fetchCampaignStatistics = async (id, setFunction) => {
    try {
      const res = await getOmanCampaignStatistics(id, dataYear);
      setFunction(res[0]);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchAllStatistics = async () => {
      await Promise.all([
        fetchCampaignStatistics(4, setCampaignStatisticsStc),
        fetchCampaignStatistics(2, setCampaignStatisticsMobily),
        fetchCampaignStatistics(3, setCampaignStatisticsZain),
        fetchCampaignStatistics(7, setCampaignStatisticsRbm),
        fetchCampaignStatistics(5, setCampaignStatisticsOmanTel),
        fetchCampaignStatistics(8, setCampaignStatisticsOreddo),
      ]);
    };

    fetchAllStatistics();
  }, [dataYear]);

  const fetchFinancialReports = async (requests, setTotal) => {
    try {
      const results = await Promise.allSettled(
        requests.map(async ({ opId, setter }) => {
          const response = await getFinancialReports({ opId, year: dataYear });
          setter(response);
          return response;
        })
      );

      let totalRevenue = 0;
      let totalSPShare = 0;
      let maxMonth = 0;

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          const data = result.value;
          totalRevenue += data.TotalRevenue || 0;
          totalSPShare += data.TotalSPShare || 0;
          maxMonth = Math.max(maxMonth, data.MaxMonth || 0);
        } else {
          console.error(`Error fetching financial report for opId ${requests[index].opId}:`, result.reason);
        }
      });

      setTotal({
        TotalRevenue: totalRevenue,
        TotalSPShare: totalSPShare,
        lastMonth: maxMonth,
      });
    } catch (error) {
      console.error("Unexpected error fetching financial reports:", error);
    }
  };

  useEffect(() => {
    const ksaRequests = [
      { opId: 3, setter: setZainFinancial },
      { opId: 4, setter: setStcFinancial },
      { opId: 2, setter: setMobilyFinancial },
      { opId: 9, setter: setZainFgcFinancial },
      { opId: 7, setter: setRBMFinancial },
    ];

    const omanRequests = [
      { opId: 5, setter: setOmanTelFinancial },
      { opId: 8, setter: setOreddoFinancial },
    ];

    fetchFinancialReports(ksaRequests, setKsaTotal);
    fetchFinancialReports(omanRequests, setOmanTotal);
  }, [dataYear]);

  return (
    <div>
      <div className="text-gray-500 flex items-center gap-2 mt-2 mb-6">
        <span className="text-xs font-semibold flex items-center">
          <FiHome size={12}/> <FiChevronRight size={12}/>
        </span>
        <h4 className="text-xs font-semibold text-gray-500">{t("GLOBAL.DASHBOARD")}</h4>
      </div>
      <div className="flex items-center justify-end">
        <div className="relative border rounded-lg px-2 py-1.5 text-sm flex items-center gap-2 bg-white w-80 col-span-2">
          <FiCalendar className="text-gray-500 absolute top-1/2 -translate-y-1/2 left-3 z-20" size={14} />
          <DatePicker
            selected={new Date(dataYear, 0, 1)}
            onChange={(date) => setDataYear(date.getFullYear())}
            dateFormat="yyyy"
            showYearPicker
            placeholderText="Select Year"
            isClearable={false}
            wrapperClassName="w-80"
            className="w-80 pl-8"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" >
        <OperatorsRevenueChartByCountry dataYear={dataYear} defaultPage={1} />
        <OperatorsRevenueChartByCountry dataYear={dataYear} defaultPage={2} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" >
        <KsaTotalMarketRevenue dataYear={dataYear} ksaTotal={ksaTotal} />
        <OmanTotalMarketRevenue dataYear={dataYear} omanTotal={omanTotal} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" >
        <TotalMarketRevenueKSATable
          dataYear={dataYear}
          openRevenueModal={openRevenueModal}
          stcFinancial={stcFinancial}
          mobilyFinancial={mobilyFinancial}
          zainFinancial={zainFinancial}
          zainFgcFinancial={zainFgcFinancial}
          RBMFinancial={RBMFinancial}
        />
        <TotalMarketRevenueOmanTable
          dataYear={dataYear}
          openRevenueModal={openRevenueModal}
          omanTelFinancial={omanTelFinancial}
          oreddoFinancial={oreddoFinancial}
        />
      </div>


      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <CampainStatisticsTable
          title={`Campaign statistics KSA ${dataYear}`}
          data={KsaCampaignStatistics}
          openStatisticsModal={openCampaignStatisticsModal}
        />
        <CampainStatisticsTable
          title={`Campaign statistics OMAN ${dataYear}`}
          data={OmanCampaignStatistics}
          openStatisticsModal={openCampaignStatisticsModal}
        />
      </div>

      <Modal isOpen={isRevenueModalOpen} close={closeRevenueModal} title={`Revenues - ${dataYear}`} >
        <RevenueModal opId={revenueModalData} dataYear={dataYear} />
      </Modal>
      <Modal isOpen={isCampaignStatisticsModal} close={closeCampaignStatisticsModal} title={`Campaign statistics - ${dataYear}`} >
        <CampaignStatisticsModal opId={revenueModalData} dataYear={dataYear} />
      </Modal>
    </div>
  );
}

export default Dashboard;
